import { useEffect, useState } from 'react'
import { Dataset, GetDatasetVersionsResponse } from 'tabs/data/api/generated'
import { getDatasets } from 'tabs/data/api/datasets'

export const useDatasets = () => {
  const [data, setData] = useState<GetDatasetVersionsResponse['datasets'] | []>([])
  const [activeDataset, setActiveDataset] = useState<Dataset | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | string | null>(null)

  const fetchDatasetVersions = async () => {
    setLoading(true)
    setError(null)

    try {
      const jsonData = await getDatasets()

      setData(jsonData.datasets || [])
    } catch (err: unknown) {
      setError((err as Error)?.message || 'An unknown error occurred')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDatasetVersions()
  }, [])

  useEffect(() => {
    if (activeDataset && data[0]) {
      setActiveDataset(activeDataset)
    }
  }, [data])

  return { data, activeDataset, setActiveDataset, loading, refetch: fetchDatasetVersions, error }
}
